<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle pageTitle="Data Vessel Class" subTitle="Forms" />

    <CreateVesselClass />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/Common/PageTitle.vue";
import CreateVesselClass from "@/components/Pages/Master/VesselClass/CreateVesselClass.vue";

export default defineComponent({
  name: "CreateVesselClassPage",
  components: {
    PageTitle,
    CreateVesselClass,
  },
});
</script>
